import React, { Suspense, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { Route, Routes } from "react-router";
import GuestRoute from "helpers/authentication/guestRoute";
import AuthRoute from "helpers/authentication/authRoute";
import Layout from "./components/Layout/Layout";
import Dashboard from "views/dashboard";
import NotFound from "views/NotFound";
import Login from "views/login";
import Logout from "views/Logout";
import { getAllSettings, getCurrentUser } from "store/actions";
import Loader from "./components/shared/Loader";
import Settings from "views/Settings";
import About from "views/about/about";
import ContactUs from "views/ContactUs";
import Socials from "views/socials";
import AddSocial from "views/socials/AddSocial";
import EditSocial from "views/socials/EditSocial";
import ShowContact from "views/ContactUs/ShowContact";
import SocialTypes from "views/socialTypes";
import AddSocialTypes from "views/socialTypes/AddSocial";
import EditSocialType from "views/socialTypes/EditSocial";
import Faqs from "views/faqs";
import Subscribers from "views/subscribers";
import AddBlog from "views/blogs/AddBlog";
import ShowBlog from "views/blogs/ShowBlog";
import AddBlogCategory from "views/blogsCategories/AddBlogCategory";
import EditBlogCategory from "views/blogsCategories/EditBlogCategory";
import Blogs from "views/blogs/Index";
import HomeBlogs from "views/home/blogs";
// import BlogCategories from "views/blogsCategories/Index";
import EditBlog from "views/blogs/EditBlog";
import Hero from "views/home/hero";
import Clients from "views/home/clients";
import HomeAbout from "views/home/about";
import AboutServices from "views/about/services";
import Services from "views/services";
import Testimonials from "views/about/testimonials";
import HomeServices from "views/home/services";
import HomeSolutions from "views/home/solutions";
import HomeSeo from "views/home/seo";
import FaqsSeo from "views/faqs/seo";
import AboutSeo from "views/about/seo";
import BlogsSeo from "views/blogs/seo";
import ServicesSeo from "views/services/seo";
import ContactSeo from "views/ContactUs/seo";
const App = () => {
  const dispatch = useDispatch();
  const token = localStorage.getItem("token");

  //selectors
  const { isLoggedIn } = useSelector((state) => state?.authentication);
  const { settings } = useSelector((state) => state.settings);
  const logo = settings?.appLogo;

  useEffect(() => {
    dispatch(getAllSettings());
  }, [dispatch]);

  useEffect(() => {
    if (token) dispatch(getCurrentUser());
  }, [token, dispatch]);

  const RenderApp = () => {
    return (
      <Suspense fallback={<div>Loading...</div>}>
        <BrowserRouter>
          <Routes>
            <Route element={<Layout logo={logo} />}>
              <Route
                path="/"
                element={
                  <AuthRoute>
                    <Dashboard />
                  </AuthRoute>
                }
              />

              {/* home  */}
              <Route
                path="/home/hero"
                element={
                  <AuthRoute>
                    <Hero />
                  </AuthRoute>
                }
              />

              <Route
                path="/home/about"
                element={
                  <AuthRoute>
                    <HomeAbout />
                  </AuthRoute>
                }
              />
              <Route
                path="/home/seo"
                element={
                  <AuthRoute>
                    <HomeSeo />
                  </AuthRoute>
                }
              />
              <Route
                path="home/clients"
                element={
                  <AuthRoute>
                    <Clients />
                  </AuthRoute>
                }
              />

              <Route
                path="home/blogs"
                element={
                  <AuthRoute>
                    <HomeBlogs />
                  </AuthRoute>
                }
              />
              <Route
                path="home/services"
                element={
                  <AuthRoute>
                    <HomeServices />
                  </AuthRoute>
                }
              />
              <Route
                path="home/solutions"
                element={
                  <AuthRoute>
                    <HomeSolutions />
                  </AuthRoute>
                }
              />
              {/* about  */}
              <Route
                path="/aboutUs/about"
                element={
                  <AuthRoute>
                    <About />
                  </AuthRoute>
                }
              />
              <Route
                path="/aboutUs/testimonials"
                element={
                  <AuthRoute>
                    <Testimonials />
                  </AuthRoute>
                }
              />
              <Route
                path="/aboutUs/services"
                element={
                  <AuthRoute>
                    <AboutServices />
                  </AuthRoute>
                }
              />
              <Route
                path="/aboutUs/seo"
                element={
                  <AuthRoute>
                    <AboutSeo />
                  </AuthRoute>
                }
              />
              {/* services  */}
              <Route
                path="/services"
                element={
                  <AuthRoute>
                    <Services />
                  </AuthRoute>
                }
              />
              <Route
                path="/services/seo"
                element={
                  <AuthRoute>
                    <ServicesSeo />
                  </AuthRoute>
                }
              />
              <Route
                path="/blogs"
                element={
                  <AuthRoute>
                    <Blogs />
                  </AuthRoute>
                }
              />
              <Route
                path="/blogs/seo"
                element={
                  <AuthRoute>
                    <BlogsSeo />
                  </AuthRoute>
                }
              />
              <Route
                path="/blogs/addblog"
                element={
                  <AuthRoute>
                    <AddBlog />
                  </AuthRoute>
                }
              />
              <Route
                path="/blogs/:id"
                element={
                  <AuthRoute>
                    <EditBlog />
                  </AuthRoute>
                }
              />

              <Route
                path="/blogs/show/:id"
                element={
                  <AuthRoute>
                    <ShowBlog />
                  </AuthRoute>
                }
              />

              {/* <Route
                path="/blogs/categories"
                element={
                  <AuthRoute>
                    <BlogCategories />
                  </AuthRoute>
                }
              /> */}

              <Route
                path="/blogs/categories/addcategory"
                element={
                  <AuthRoute>
                    <AddBlogCategory />
                  </AuthRoute>
                }
              />
              <Route
                path="/blogs/categories/:id"
                element={
                  <AuthRoute>
                    <EditBlogCategory />
                  </AuthRoute>
                }
              />
              {/* faqs */}
              <Route
                path="/faqs"
                element={
                  <AuthRoute>
                    <Faqs />
                  </AuthRoute>
                }
              />
              <Route
                path="/faqs/seo"
                element={
                  <AuthRoute>
                    <FaqsSeo />
                  </AuthRoute>
                }
              />
              {/* contact */}
              <Route
                path="/contactUs"
                element={
                  <AuthRoute>
                    <ContactUs />
                  </AuthRoute>
                }
              />
              <Route
                path="/contactUs/seo"
                element={
                  <AuthRoute>
                    <ContactSeo />
                  </AuthRoute>
                }
              />
              <Route
                path="/contactUs/show/:id"
                element={
                  <AuthRoute>
                    <ShowContact />
                  </AuthRoute>
                }
              />
              {/* socials */}
              <Route
                path="/socials"
                element={
                  <AuthRoute>
                    <Socials />
                  </AuthRoute>
                }
              />

              <Route
                path="/socials/addSocial"
                element={
                  <AuthRoute>
                    <AddSocial />
                  </AuthRoute>
                }
              />

              <Route
                path="/socials/:id"
                element={
                  <AuthRoute>
                    <EditSocial />
                  </AuthRoute>
                }
              />
              {/* socialTypes */}
              <Route
                path="/socialTypes"
                element={
                  <AuthRoute>
                    <SocialTypes />
                  </AuthRoute>
                }
              />

              <Route
                path="/socialTypes/addSocial"
                element={
                  <AuthRoute>
                    <AddSocialTypes />
                  </AuthRoute>
                }
              />

              <Route
                path="/socialTypes/:id"
                element={
                  <AuthRoute>
                    <EditSocialType />
                  </AuthRoute>
                }
              />
              {/* subscribers */}
              <Route
                path="/subscribers"
                element={
                  <AuthRoute>
                    <Subscribers />
                  </AuthRoute>
                }
              />
              <Route
                path="/settings"
                element={
                  <AuthRoute>
                    <Settings />
                  </AuthRoute>
                }
              />

              <Route
                path="*"
                element={
                  <AuthRoute>
                    <NotFound />
                  </AuthRoute>
                }
              />
            </Route>

            {/*Auth Routes */}
            <Route
              path="/logout"
              element={
                <AuthRoute>
                  <Logout />
                </AuthRoute>
              }
            />
            <Route
              path="/login"
              element={
                <GuestRoute>
                  <Login logo={logo} />
                </GuestRoute>
              }
            />
          </Routes>
        </BrowserRouter>
      </Suspense>
    );
  };

  if (!token) return RenderApp();
  if (isLoggedIn !== null) return RenderApp();
  return <Loader />;
};

export default App;
